module.exports = __webpack_public_path__ + "static/media/180-D-circle.eb6c3bd0.svg";